import React from "react";
import { observer, inject } from "mobx-react";
import { observable, action } from "mobx";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { FormControl } from "react-bootstrap";
import debounce from "lodash/debounce";

@injectIntl
@inject("rootStore")
@observer
export default class LanesNotesFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterQuery: ""
    };

    // de-bounce the filter by 400ms, prevent multiple calls
    this.triggerFilterQuery = debounce(this.triggerFilterQuery, 400);
  }

  render() {
    const { intl, rootStore, ...props } = this.props;

    return (
      <FormControl
        type="text"
        value={this.state.filterQuery}
        onChange={this.handleFilterQueryChange}
        placeholder={intl.formatMessage({ id: "filter_tasks_placeholder" })}
        {...props}
      />
    );
  }

  handleFilterQueryChange = e => {
    this.setState({ filterQuery: e.target.value });
    this.triggerFilterQuery(e.target.value);
  };

  triggerFilterQuery = query => {
    const { rootStore } = this.props;

    rootStore.filterQuery = query;
  };
}

LanesNotesFilter.propTypes = {};
